import { render, staticRenderFns } from "./ScrollAlert.vue?vue&type=template&id=0cf7f284&scoped=true"
import script from "./ScrollAlert.vue?vue&type=script&lang=js"
export * from "./ScrollAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7f284",
  null
  
)

export default component.exports